// extracted by mini-css-extract-plugin
export default {"movie__area":"Movies_movie__area__s4gVf","content_area":"Movies_content_area__q3HWV"};